// 申诉状态
export const appealOption = [
  {
    value: 0,
    label: '未申诉'
  },
  {
    value: 1,
    label: '申诉中'
  },
  {
    value: 2,
    label: '申诉通过'
  },
  {
    value: 3,
    label: '申诉不通过'
  },
  {
    value: 4,
    label: '已确认'
  }
]
// 违规处理
export const violationsOption = [
  {
    value: 0,
    label: '警告'
  },
  {
    value: 1,
    label: '罚款'
  }
]
export const inspectionOption = [
  {
    value: 0,
    label: '餐饮卫生'
  },
  {
    value: 1,
    label: '有无投诉'
  },
  {
    value: 2,
    label: '迎宾'
  },
  {
    value: 3,
    label: '是否准时开店'
  },
  {
    value: 4,
    label: '是否准时闭店'
  },
  {
    value: 5,
    label: '送宾'
  },
  {
    value: 6,
    label: '其他'
  },
  {
    value: 7,
    label: '亮证经营'
  },
  {
    value: 8,
    label: '经营状况'
  },
  {
    value: 9,
    label: '广场活动'
  },
  {
    value: 10,
    label: '店内环境'
  },
  {
    value: 11,
    label: '装修情况'
  }
]
